import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PATINPerfis.css";

const API = "/api/patin/auth";

export default function PATINMentora() {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState(null);
  const [participantes, setParticipantes] = useState([]);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      try {
        const respostaUsuario = await fetch(`${API}/me`, {
          credentials: "same-origin"
        });

        if (respostaUsuario.status === 401) {
          navigate("/patin/login", { replace: true });
          return;
        }

        if (!respostaUsuario.ok) {
          throw new Error("Não foi possível verificar sua sessão.");
        }

        const dadosUsuario = await respostaUsuario.json();

        if (dadosUsuario.perfil !== "consultora") {
          navigate("/patin/meu-plano", { replace: true });
          return;
        }

        const resposta = await fetch(`${API}/minhas-mentoradas`, {
          credentials: "same-origin"
        });

        if (!resposta.ok) {
          throw new Error("Não foi possível carregar suas mentoradas.");
        }

        const dados = await resposta.json();

        if (ativo) {
          setUsuario(dadosUsuario);
          setParticipantes(dados.participantes || []);
        }
      } catch (error) {
        if (ativo) setErro(error.message);
      } finally {
        if (ativo) setCarregando(false);
      }
    }

    carregar();

    return () => {
      ativo = false;
    };
  }, [navigate]);

  async function sair() {
    await fetch(`${API}/logout`, {
      method: "POST",
      credentials: "same-origin"
    });

    navigate("/patin/login", { replace: true });
  }

  if (carregando) {
    return <main className="patin-perfis">Carregando...</main>;
  }

  return (
    <main className="patin-perfis">
      <section className="patin-painel">
        <header className="patin-painel-header">
          <div>
            <div className="patin-etiqueta">ÁREA DA MENTORA</div>
            <h1>Olá, {usuario?.nome || "Mentora"}!</h1>
            <p>Acompanhe as empreendedoras sob sua responsabilidade.</p>
          </div>

          <button className="patin-sair" onClick={sair}>
            Sair
          </button>
        </header>

        {erro ? (
          <div className="patin-erro" role="alert">{erro}</div>
        ) : (
          <>
            <div className="patin-indicador">
              <span>Mentoradas vinculadas</span>
              <strong>{participantes.length}</strong>
            </div>

            <h2>Minhas mentoradas</h2>

            {participantes.length === 0 ? (
              <p>Nenhuma mentorada vinculada até o momento.</p>
            ) : (
              <div className="patin-lista">
                {participantes.map((p) => (
                  <article
                    className="patin-participante"
                    key={p.protocolo}
                  >
                    <div>
                      <h3>{p.nome}</h3>
                      <p>{p.nome_negocio || "Negócio não informado"}</p>
                      <small>Protocolo: {p.protocolo}</small>
                    </div>

                    <span className="patin-status">
                      {p.status || "Sem status"}
                    </span>
                  </article>
                ))}
              </div>
            )}
          </>
        )}
      </section>
    </main>
  );
}
